var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"span-gerar",attrs:{"large":""}},[_c('span',{staticClass:"loading-spinner"}),_c('span',[_vm._v("GERANDO RESERVAS, AGUARDE.")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }